import { Box, StackDivider, VStack } from '@chakra-ui/react';
import { IOption, IVariant } from '../../../../../../../interfaces';

import OptionItem from '../optionItem/OptionItem';

interface Props {
    options: IOption[];
}

export default function OptionList({ options }: Props) {
    return (
        <Box>
            <VStack divider={<StackDivider borderColor="#485765" />} spacing={4} align="stretch">
                {options.map((option, index) => (
                    <OptionItem option={option} key={index} />
                ))}
            </VStack>
        </Box>
    );
}
